import styled from "styled-components";
import zIndexTypes from "../../../../theme/zIndexTypes";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const IconWrapper = styled.div`
  .sidebar__briefcase {
    font-size: 0.65em !important;
    position: relative;
    left: -5px;
    top: -10px;
  }

  .search {
    position: absolute;
    right: 12px;
    font-size: 0.7em !important;
    top: 5px;
    padding: 7px 0px 5px 13px;
    margin-right: 0;
    height: 35px;
    width: 40px;
  }
`;

export const SidebarWrapper = styled.div`
  position: fixed;
  margin-top: 60px;
  width: 60px;
  height: 100%;
  background-color: #402680;
  z-index: ${zIndexTypes.sidebar};

  ${IconWrapper} {
    font-size: 2.1em;
    color: #fff;
    height: 40px;
    text-align: center;
    margin: 27px 0;
    position: relative;
    transition: 0.1s ease-in-out;

    &:hover {
      cursor: pointer;
      color: #79D9D9;
    }

    i {
      font-size: 0.9em;
      -webkit-text-stroke: 1px #1d212a;
    }
  }

  ${mediaMaxWidth.tablet`
    display: none;
  `}
`;

export const Credits = styled.div`
  position: relative;

  .content {
    position: absolute;
    top: -4px;
    left: 56px;
    font-size: 1em;
    background: #fff;
    color: #333;

    &::after {
      border-right-color: #fff;
    }
  }
`;

export const CreditCount = styled.div`
  background: #27ae60;
  text-align: center;
  border-radius: 50%;
  color: #fff;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 25px auto;
  font-family: sans-serif;
  font-size: 1.3em;
  font-weight: 700;
  position: relative;

  &:hover {
    cursor: pointer;
  }
`;

export const MenuOption = styled.a``;
export const MenuOptionWithChildren = styled.div``;

export const Content = styled.div`
  position: relative;
  left: 55px;
  top: -45px;
  width: max-content;
  background: #79D9D9;
  padding: 10px 15px;
  font-size: 0.5em;
  color: #fff;
  border-radius: 4px;
  border: 1px solid #fff;
  text-transform: uppercase;
  font-weight: 600;
  text-align: left;
  box-shadow: 0 0 5px #565656;
  letter-spacing: 1px;
  display: none;

  &.show {
    display: inline-block !important;
  }

  &::after,
  &::before {
    right: 100%;
    top: 22px;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &::after {
    border-color: rgba(136, 183, 213, 0);
    border-right-color: #79D9D9;
    border-width: 6px;
    margin-top: -6px;
  }

  &::before {
    border-color: rgba(194, 225, 245, 0);
    border-right-color: #fff;
    border-width: 8px;
    margin-top: -8px;
  }
`;

export const Sublink = styled.a`
  position: relative;
  display: block;
  color: #bdbdbd !important;
  padding: 5px 0;
  min-width: 140px;

  i {
    font-size: 0.9em;
    width: 30px;
    text-align: left;
    color: #bdbdbd;
    -webkit-text-stroke: 0px !important;
  }

  &:hover {
    color: #fff !important;

    i {
      color: #fff;
    }
  }

  &:first-child {
    margin-top: 20px;
  }
`;

export const Dot = styled.span`
  position: absolute;
  height: 12px;
  width: 12px;
  background: #79D9D9;
  border-radius: 50%;
  right: 11px;
  top: 7px;
`;

export const InlineDot = styled.span`
  position: absolute;
  height: 12px;
  width: 12px;
  background: #79D9D9;
  border-radius: 50%;
  top: 10px;
  margin-left: 10px;
`;

export const BetaBadge = styled.div`
  position: absolute;
  right: 5px;
  top: 4px;
  font-size: 0.25em;
  text-transform: uppercase;
  background-color: #79D9D9;
  color: #fff;
  padding: 2px 5px;
  font-weight: 700;
  border-radius: 25px;
  pointer-events: none;
`;
